import { filterJobs } from "../modules/filter-jobs";
import { loadJobs } from "../modules/load-jobs";

const jobsPage = (gsap, smoother, ScrollTrigger) => {
    
  const $jobsFilter = $('.jobs-filter');
  const $jobListings = $('.open-positions');
    
  if ($jobListings.length) {
    loadJobs(gsap, smoother, ScrollTrigger);
  }
  
  if ($jobsFilter.length) {
    filterJobs(gsap, ScrollTrigger);
  }
  
}

export {
  jobsPage
};
